import { Badge } from 'antd';
import React, { FC, ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { AccountId, UserId } from 'api/models';
import { TabIcon } from 'components/atoms/menu/compact-menu';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { useAccount } from 'hooks/use-account';
import { useUser } from 'hooks/use-user';
import { initialize } from 'stores/notifications/use-pending';
import styles from './notifications-badge.module.css';

interface Props extends ClassNameOnlyProps {
  text: React.ReactNode;
  pending: number;
  icon?: ReactNode;
  width?: string;
  titleClassName?: string;
}

export const Title = styled.span<{ width?: string }>`
  overflow: hidden;
  display: flex;
  align-items: center;
  width: ${(props) => props.width};
  height: 100%;
`;

export const NotificationsBadge: FC<Props> = ({
  text,
  pending,
  className,
  icon,
  width,
  titleClassName,
}) => {
  const {
    user: { userId },
  } = useUser();
  const { accountId } = useAccount();

  useEffect(() => {
    initialize(UserId(userId), AccountId(accountId));
  }, [accountId, userId]);

  return (
    <Title width={width} className={titleClassName}>
      {icon != null && <TabIcon>{icon}</TabIcon>}
      <Badge dot={pending > 0} className={`${styles.new} ${className}`}>
        {text}
      </Badge>
    </Title>
  );
};
